import React from 'react';
import classes from './upperHeaderShippingMessage.css';
import { FormattedMessage } from 'react-intl';
import { useStoreSwitcher } from "@magento/peregrine/lib/talons/Header/useStoreSwitcher";
import { useQuery } from "@apollo/client";
import { GET_FREE_SHIPPING_THRESHOLD } from "../../CartPage/cartPage.gql";
import { sendGTMEvent } from "../../../util/initGTM";
import { BrowserPersistence } from "@magento/peregrine/lib/util";
import BBLink from "../../BBLink";
var storage = new BrowserPersistence();
var UpperHeaderShippingMessage = () => {
  var _dataFreeShipping$fre;
  var {
    currentStoreCode
  } = useStoreSwitcher();
  var {
    data: dataFreeShipping
  } = useQuery(GET_FREE_SHIPPING_THRESHOLD, {
    fetchPolicy: 'network-only',
    variables: {
      websiteId: 1
    }
  });
  var amount = (dataFreeShipping === null || dataFreeShipping === void 0 || (_dataFreeShipping$fre = dataFreeShipping.freeShippingThreshold) === null || _dataFreeShipping$fre === void 0 ? void 0 : _dataFreeShipping$fre.threshold) || 0;
  var isEn = currentStoreCode && currentStoreCode.includes("en");
  var url = "/".concat(isEn ? "shipping-and-returns" : "livraison-et-retour");
  var updateGtm = () => {
    var currentPath = storage.getItem("currentPath");
    if (currentPath.includes('cart')) {
      sendGTMEvent({
        eventCategory: 'checkout step 1 - cart',
        eventAction: 'Free shippin notice at the top',
        eventLabel: 'Click on see details',
        event: 'genericGAEvent'
      });
    }
    if (currentPath.includes('checkout')) {
      sendGTMEvent({
        eventCategory: 'checkout step 2 - contact information',
        eventAction: 'Free shipping notice at the top',
        eventLabel: 'Click on see details',
        event: 'genericGAEvent'
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.shippingContainer
  }, /*#__PURE__*/React.createElement(BBLink, {
    className: classes.freeShippingMessage,
    to: url,
    onClick: updateGtm
  }, /*#__PURE__*/React.createElement("p", null, isEn ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: classes.free
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'header.free',
    defaultMessage: 'Free'
  })), ' ', /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'header.delivery',
    defaultMessage: 'delivery'
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'header.delivery',
    defaultMessage: 'Livraison'
  }), ' ', /*#__PURE__*/React.createElement("span", {
    className: classes.free
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'header.free',
    defaultMessage: 'gratuite'
  }))), ' ', /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'header.onOrdersFrom',
    defaultMessage: 'on any purchase of ${amount}+',
    values: {
      amount
    }
  }))));
};
export default UpperHeaderShippingMessage;